import { lazy, Suspense } from 'react'

import { defineMessages } from 'react-intl'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { userReportConfig } from '@webapp/modules/reports/config/reportConfigs'

const ReportAggregateViewChunk = lazy(() =>
  import('../../feature-sets/ReportAggregateView').then(
    ({ ReportAggregateView }) => ({
      default: ReportAggregateView,
    })
  )
)

const scope = `procurify.modules.reports.pages.OrdersByUserReportPage`

const messages = defineMessages({
  // Angular's singular "Order by user" anomaly is intentionally corrected (BHV-014).
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Orders by user',
  },
})

export const OrdersByUserReportPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.pageTitle)}
      breadcrumbs={[{ name: intl.formatMessage(messages.pageTitle) }]}
    >
      <div data-testid='orders-by-user-report-page'>
        <Suspense fallback={null}>
          <ReportAggregateViewChunk reportConfig={userReportConfig} />
        </Suspense>
      </div>
    </Page>
  )
}
